module.exports = __webpack_public_path__ + "img/restaurant_1_truck.549a00e7.jpg";